import { type FC } from "react";
import * as styles from "./styles.css";

type Props = {
  currentStep: number;
  totalSteps: number;
};

export const StepIndicator: FC<Props> = ({ currentStep, totalSteps }) => {
  const progress = Math.min(Math.max((currentStep / totalSteps) * 100, 0), 100);
  return (
    <div className={styles.chartWrapper}>
      <div className={styles.chart}>
        <div className={styles.chartItem} style={{ width: `${progress}%` }} />
      </div>
    </div>
  );
};
